import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormCategory from './Form/FormCategory'

function EditCategory({id , btCancelAction, handleOnSuccess}){
    const [category, setCategory] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/category/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setCategory(response.data.category)
        })
    }, [token, id])

    async function updateCategory(category) {
        let msgType = 'success'


        const data = await api.patch(`category/update/${category._id}`, category, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        category.name && (
            <FormCategory title="Editar Categoria" handleSubmit={updateCategory} btnText="Salvar" btCancelAction={btCancelAction} categoryData={category} />
        )
    )
}

export default EditCategory
